import { Table } from '@mantine/core';

import { trafficSourceTypes } from '../../types';

import { BodyRow } from './BodyRow';

type TrafficSourcesTableProps = {
  trafficSources: trafficSourceTypes.TrafficSource[];
};

export function TrafficSourcesTable({ trafficSources }: TrafficSourcesTableProps) {
  return (
    <Table stickyHeader striped highlightOnHover>
      <Table.Thead>
        <Table.Tr>
          <Table.Th>Название</Table.Th>
          <Table.Th>Ключ</Table.Th>
          <Table.Th>Команда</Table.Th>
          <Table.Th>Действия</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {trafficSources?.map((trafficSource) => <BodyRow trafficSource={trafficSource} />)}
      </Table.Tbody>
    </Table>
  );
}
